import { ReactNode } from 'react';

import styles from '../Carousel.module.css';

export type CarouselDescriptionContainerProps = {
	children: ReactNode;
	slot?: string;
};

export const CarouselDescriptionContainer = ({ children, slot }: CarouselDescriptionContainerProps) => {
	return (
		<div
			data-description-container
			className={styles.descriptionContainer}
			slot={slot}
		>
			{children}
		</div>
	);
};

export type CarouselDescriptionProps = {
	children: ReactNode;
};

export const CarouselDescription = ({ children }: CarouselDescriptionProps) => {
	return (
		<div
			data-description
			className={styles.description}
		>
			{children}
		</div>
	);
};
